var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 -0.00240857C18.6274 -0.00240857 24 5.37017 24 11.9976C24 18.625 18.6274 23.9976 12 23.9976C5.37258 23.9976 0 18.625 0 11.9976C0 5.37017 5.37258 -0.00240857 12 -0.00240857Z",
    fill: "#00BD00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63634 15.3712L6.33542 12.6291C5.97191 12.1959 6.02867 11.5508 6.46231 11.187C6.89537 10.8236 7.54048 10.8797 7.90399 11.3129L9.52295 13.2423L16.2002 7.63949C16.6338 7.27562 17.2789 7.33173 17.6419 7.76436C18.0054 8.19757 17.9487 8.84263 17.515 9.2065L10.2676 15.2878C10.2158 15.3641 10.1527 15.4345 10.0786 15.4967C9.64496 15.8606 8.99935 15.8039 8.63634 15.3712Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green-tick.609bc82df64033f06a90811592b33544.svg";
export { ForwardRef as ReactComponent };